<template>
  <div
    class="nlp__burger-menu-box"
    :class="{ 'nlp__burger-menu-box--open': getBurgerMenuState && isNlpMobile }"
  >
    <div
      class="nlp__burger-menu-item"
      @click="handleBurgerMenuClick('.nlp__why-check')"
    >
      Risks
    </div>
    <div
      class="nlp__burger-menu-item"
      @click="handleBurgerMenuClick('.nlp__why-satoshi')"
    >
      Solutions
    </div>
    <div
      class="nlp__burger-menu-item"
      @click="handleBurgerMenuClick('.nlp__pricing')"
    >
      Pricing
    </div>
    <div
      class="nlp__burger-menu-item"
      @click="handleBurgerMenuClick('.nlp__faq')"
    >
      FAQ
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

// Utils
import { nlpScrollToViewSelector } from '@/utils/scroll-to'

export default {
  name: 'NlpBurgerMenu',
  mixins: [deviceWidthMixin],
  computed: {
    ...mapGetters('nlp', ['getBurgerMenuState']),
  },
  methods: {
    nlpScrollToViewSelector,
    handleBurgerMenuClick(selector) {
      this.nlpScrollToViewSelector(selector, -96)
      this.$store.commit('nlp/SET_BURGER_MENU_STATE', false)
    },
  },
}
</script>

<style>
.nlp__burger-menu-box {
  display: flex;
  flex-direction: column;
  gap: 32px;
  opacity: 0;
  width: 100dvw;
  height: 100dvh;
  padding: 100px 16px 24px 16px;
  background-color: #F7FAFC;
  position: fixed;
  top: 0;
  left: -100dvw;
  z-index: 4;
  transition: all 0.3s ease;
  pointer-events: none;
}
.nlp__burger-menu-box--open {
  opacity: 1;
  left: 0;
  pointer-events: auto;
}
.nlp__burger-menu-item {
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
  color: #5A627D;
}
</style>